import { FormGroup } from '@angular/forms';

export function IsValue(controlName: string, value: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];

        if (!control.value || control.errors && !control.errors['wrongValue']) {
            return;
        }

    if (!control.value.toString().includes(value)) {
        control.setErrors({ wrongValue: true });
    }
    }
    
}